import React, { useState, useEffect, useRef } from 'react';

const stats = [
  { value: 15, suffix: '+', label: 'Événements réalisés' },
  { value: 500, suffix: '+', label: 'Invités servis' },
  { value: 5, suffix: '/5', label: 'Note Google' },
  { value: 100, suffix: '%', label: 'Clients satisfaits' }
];

const AnimatedNumber = ({ value, suffix }) => {
  const [count, setCount] = useState(0);
  const ref = useRef(null);
  const started = useRef(false);

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting && !started.current) {
        started.current = true;
        let start = 0;
        const duration = 1500;
        const step = Math.ceil(value / (duration / 16));
        const timer = setInterval(() => {
          start += step;
          if (start >= value) {
            setCount(value);
            clearInterval(timer);
          } else {
            setCount(start);
          }
        }, 16);
      }
    });
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, [value]);

  return (
    <span ref={ref} className="text-5xl font-bold text-gold">
      {count}{suffix}
    </span>
  );
};

const Stats = () => {
  return (
    <section className="py-16 bg-charcoal border-y border-cream/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
          {stats.map((stat, i) => (
            <div key={i} className="flex flex-col items-center gap-2">
              <AnimatedNumber value={stat.value} suffix={stat.suffix} />
              <p className="text-cream">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Stats;
